import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../utils/api'; // your axios instance with auth
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function InvitePage() {
  const query = useQuery();
  const token = query.get('token');
  const navigate = useNavigate();

  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    async function validate() {
      if (!token) {
        setError('Invalid or missing invite token.');
        setLoading(false);
        return;
      }
      try {
        const res = await api.get(`/api/invites/validate?token=${token}`);
        setInvite(res.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Invalid or expired invite link');
      } finally {
        setLoading(false);
      }
    }
    validate();
  }, [token]);

  const handleJoin = async () => {
    setJoining(true);
    try {
      const res = await api.post('/api/invites/join-group', { token });
      toast.success('Successfully joined the group!', { autoClose: 1500 });

      const joinedGroup = res.data?.group || res.data;

      if (joinedGroup && joinedGroup._id && joinedGroup.supplierId) {
        // Handle supplierId if it's populated or just an ID string
        const supplierId =
          typeof joinedGroup.supplierId === 'object'
            ? joinedGroup.supplierId._id || joinedGroup.supplierId
            : joinedGroup.supplierId;

        navigate(`/GroupSearchAndJoin?supplierId=${supplierId}&groupId=${joinedGroup._id}`);
      } else {
        navigate('/GroupSearchAndJoin');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to join group');
    } finally {
      setJoining(false);
    }
  };

  if (loading) return <p className="p-6 text-center">Loading invite info...</p>;
  if (error) return <p className="p-6 text-center text-red-600">{error}</p>;

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded shadow">
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      <h2 className="text-2xl font-bold mb-4">You're invited to join group:</h2>
      <p><strong>{invite.group?.name}</strong></p>
      <p><strong>Invited Email:</strong> {invite.email}</p>
      <button
        onClick={handleJoin}
        disabled={joining}
        className="mt-6 w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 disabled:opacity-50"
      >
        {joining ? 'Joining...' : 'Join Group'}
      </button>
    </div>
  );
}
